var map = {
	"./000Thailand Post25.png": "oIdj",
	"./2C2P_Pte_Ltd 1.png": "+PdQ",
	"./COD.png": "xK71",
	"./EMS-ship.png": "HGh3",
	"./EMS.png": "F8RM",
	"./Facebookface.png": "9auV",
	"./Flash-Express.png": "tCUU",
	"./Flash-ship.png": "z5jH",
	"./Flash.png": "FHk9",
	"./Frame.png": "K39x",
	"./Kerry.png": "Vym6",
	"./Line.png": "L5LN",
	"./Logo-App-Goship.png": "SdNF",
	"./Rectangle 1989.png": "9Qa5",
	"./Rectangle-1989.png": "WPdG",
	"./Salepage.png": "vCe0",
	"./ThailandPost_Logo.png": "S4N+",
	"./_EMS-ship.png": "4Cdp",
	"./_filter-EMS.png": "Vnow",
	"./_i-thaipost.png": "wJD1",
	"./access_not_available.png": "nMHF",
	"./access_not_available_v2.png": "wu8s",
	"./active-shipping-credit-5.png": "PMQ2",
	"./active-shipping-credit-6.png": "jXz4",
	"./active-shipping-credit-8.png": "2epA",
	"./active-shipping-credit.png": "IPSm",
	"./add-wallet.png": "njCe",
	"./authorization/_body-bg.png": "9mnx",
	"./authorization/authorize_market_place_failed.png": "yZBm",
	"./authorization/authorize_market_place_success.png": "DmHA",
	"./authorization/body-bg.png": "EumS",
	"./authorization/logo go_ship_02.png": "2eTF",
	"./authorization/logo-goship-gosell.png": "yVL4",
	"./authorization/package.png": "Gp7H",
	"./authorization/shopping-cart.png": "e/7f",
	"./authorization/team.png": "qHEm",
	"./b-facebook.png": "YE1q",
	"./b-flash.png": "Uoyk",
	"./b-kerry.png": "/fDn",
	"./b-line.png": "3h60",
	"./b-thpost.png": "YGiq",
	"./backgrounds/boxed_bg.png": "hLqB",
	"./backgrounds/boxed_bg_retina.png": "1kIq",
	"./backgrounds/panel_bg.png": "AtL5",
	"./backgrounds/seamless.png": "pPp0",
	"./backgrounds/user_bg1.png": "oDOZ",
	"./banner-integration_carrier.png": "hmao",
	"./brands/Untitled-1.png": "UFKc",
	"./brands/adwords.png": "wFAF",
	"./brands/amazon.png": "ROZt",
	"./brands/bing.png": "F2TX",
	"./brands/dribbble.png": "FE4K",
	"./brands/facebook.png": "YEYk",
	"./brands/spotify.png": "w8F2",
	"./brands/tripadvisor.png": "D9NK",
	"./brands/twitter.png": "I82Z",
	"./brands/youtube.png": "VBhH",
	"./bt-kbank.png": "8d3Z",
	"./bt-scb.png": "RYQr",
	"./btn_fb_contact1.png": "zUxe",
	"./btn_fb_contact2.png": "7gu1",
	"./btn_line_contact1.png": "UBo1",
	"./btn_line_contact2.png": "8UTP",
	"./btn_tel_contact1.png": "FGC4",
	"./btn_tel_contact2.png": "Xs2C",
	"./calendar-event.png": "AHnK",
	"./carriers/4-info.png": "0Uku",
	"./carriers/4.png": "InFN",
	"./carriers/5-info.png": "5CtU",
	"./carriers/5.png": "/hE8",
	"./carriers/6-info.png": "Bl3t",
	"./carriers/6.png": "2dg4",
	"./carriers/8-info.png": "ndX2",
	"./carriers/8.png": "uXfV",
	"./carriers/9.png": "xpUC",
	"./carriers/FLASH_EXPRESS.png": "BT0j",
	"./carriers/__5.png": "u4zg",
	"./carriers/c-info-dhl.png": "Rt0h",
	"./carriers/c-info-flash.png": "11vD",
	"./carriers/c-info-jt.png": "SN/M",
	"./carriers/c-info-kerry.png": "Vwq7",
	"./carriers/c-info-thaipost.png": "4h5I",
	"./carriers/i-jt.png": "A/72",
	"./carriers/i-kerry.png": "mqX/",
	"./carriers/info-best-logo.png": "zukF",
	"./carriers/info-dhl-logo.png": "4u+v",
	"./carriers/info-flash-logo.png": "M/+x",
	"./carriers/info-jt-logo.png": "TDwk",
	"./carriers/info-kerry-logo.png": "5OXP",
	"./carriers/info-ninja-logo.png": "09Jw",
	"./carriers/info-shopee-logo.png": "6qfc",
	"./carriers/info-thaipost-logo.png": "4h77",
	"./channels/1.png": "8YZk",
	"./channels/2.png": "sZjO",
	"./channels/3.png": "ezXf",
	"./coming-soon.png": "wPnU",
	"./comming-soon-feature.png": "TRME",
	"./commingsoon.png": "lce/",
	"./contact-center1.png": "Un9I",
	"./contact-center2.png": "bzfE",
	"./contact-center3.png": "MWW8",
	"./contact-center4.png": "B98g",
	"./dashboard/Group.png": "ANVx",
	"./dashboard/Logo-free.png": "zwYK",
	"./dashboard/Logo-gosell.png": "pFvL",
	"./dashboard/Logo-gosellcoth-free.png": "8dyc",
	"./dashboard/Logo-goship.png": "kVU4",
	"./dashboard/Logo-goshipcoth-free.png": "Ja8F",
	"./dashboard/checklist.png": "lHdX",
	"./dashboard/coin-2.png": "Hb/z",
	"./dashboard/coin.png": "sTnW",
	"./dashboard/delivery-box.png": "Vz34",
	"./dashboard/delivery.png": "LcDI",
	"./dashboard/wine-glass-crack-solid.png": "Nfzp",
	"./demo_page.png": "SOR2",
	"./demo_page_2.png": "KqmB",
	"./demo_profile.png": "KRZM",
	"./demo_profile2.png": "Xr3C",
	"./demo_profile3.png": "P/Xn",
	"./demo_profile4.png": "x9/7",
	"./demo_profile5.png": "yJdV",
	"./demo_profile_call.png": "cvEW",
	"./dribbble.png": "AHEf",
	"./email1.png": "5YQJ",
	"./example_file.png": "7OuR",
	"./exclamation-circle-light-1.png": "jNRO",
	"./facebook-4.png": "6ydW",
	"./facebook4.png": "+BRZ",
	"./failed.png": "FuVk",
	"./filter-EMS.png": "NL7T",
	"./filter-Kerry.png": "gakA",
	"./filter-jt.png": "PcnN",
	"./flash-right.png": "XieP",
	"./grongnoi_mee_gunjae_mee_akegasan.png": "uEPO",
	"./grongnoi_mee_x_me_akegasan.png": "nXy1",
	"./home/banner_pic.png": "IuNG",
	"./home/howto_pic.png": "4BUH",
	"./home/htb_order_pic.png": "z+/y",
	"./home/htb_product_pic.png": "pSkn",
	"./home/htb_shipping_pic.png": "2HzR",
	"./home/sub_banner_pic1.png": "/4js",
	"./home/sub_banner_pic2.png": "UrR3",
	"./i-crm.png": "o6zF",
	"./i-dhl.png": "Bp8L",
	"./i-facebook.png": "eJmM",
	"./i-flash.png": "aWJD",
	"./i-instragram.png": "WhA0",
	"./i-jt.png": "uxQP",
	"./i-kerry.png": "YQl+",
	"./i-line-oa.png": "3RbB",
	"./i-line.png": "uYuf",
	"./i-thaipost.png": "zTGV",
	"./i-tiktok.png": "4w3w",
	"./i-youtube.png": "rre2",
	"./i_facebook.png": "jLM/",
	"./i_line.png": "84Vc",
	"./i_telesales.png": "dQNV",
	"./i_tiktok.png": "IVlu",
	"./i_uniqlo.png": "i/ZZ",
	"./ic-telesale.png": "StOi",
	"./ic-tiktok.png": "Ihro",
	"./icon-bank.png": "MSDY",
	"./icon-credit.png": "gXTZ",
	"./icon-gosell.png": "A3Bm",
	"./icon-payment-kbank.png": "IpmS",
	"./icon-payment-qr.png": "Zr2o",
	"./icon-qr.png": "toTm",
	"./icon-thai.png": "n93v",
	"./icon-us.png": "0gSp",
	"./icon_logo_facebook.png": "xH0y",
	"./icon_logo_google.png": "5NYA",
	"./icon_logo_line.png": "ll+6",
	"./image-storecenter.png": "9TDJ",
	"./image.png": "sfoY",
	"./img-limit-website.png": "sfOl",
	"./img-norty.png": "b1uo",
	"./img-preparing.png": "5onf",
	"./img-products.png": "WAWx",
	"./img-sellfacebook.png": "YCu4",
	"./img-sendmail.png": "rLeQ",
	"./img-setupstore.png": "aOhX",
	"./img-sms.png": "UraY",
	"./img_dhl.png": "sZAG",
	"./integate-banner1.png": "WJUP",
	"./integate-banner2.png": "oTjf",
	"./integate-banner3.png": "MRN9",
	"./integate-banner4.png": "aj6R",
	"./inventory/Congratulation.png": "n6Wm",
	"./inventory/accessNotAvailable.png": "2XUn",
	"./inventory/available-box.png": "+kCO",
	"./inventory/campaign-box.png": "xM8E",
	"./inventory/disconnectIntegation.png": "/lve",
	"./inventory/expiredIntegation.png": "dOvj",
	"./inventory/inventory-icon.png": "/aVR",
	"./inventory/reserved-box.png": "f5Ae",
	"./inventory/salable-box.png": "rMqj",
	"./inventory/subscriptionExpired.png": "u+us",
	"./inventory_.png": "Jche",
	"./inventory_2.png": "5Qs6",
	"./kbank.png": "dSsq",
	"./kerry-ship.png": "o4uI",
	"./ktb.png": "/d3r",
	"./lang/de.png": "XrhS",
	"./lang/es.png": "ylet",
	"./lang/gb.png": "g+Eq",
	"./lang/it.png": "YD0e",
	"./lang/ru.png": "EZNz",
	"./lang/ua.png": "meus",
	"./limit-store.png": "5kPF",
	"./locked.png": "DZpS",
	"./logo-Kbang 1.png": "TWuR",
	"./logo-Kbang-1.png": "+8C+",
	"./logo-goship-gosell-white.png": "B73Z",
	"./logo.png": "+0LV",
	"./logo_apple.png": "ArYx",
	"./logo_dark.png": "hOhv",
	"./logo_demo.png": "SRJv",
	"./logo_facebook.png": "+dqi",
	"./logo_go_ship.png": "aTDO",
	"./logo_google.png": "07N7",
	"./logo_gosell.png": "us48",
	"./logo_goship.png": "ShJD",
	"./logo_icon_dark.png": "KOtm",
	"./logo_icon_light.png": "QQk+",
	"./logo_light.png": "vSXw",
	"./logo_line.png": "KyIE",
	"./mkp-access-available.png": "nsGa",
	"./mkp-expired-integration.png": "NR47",
	"./mkp-subscription-expired.png": "ku3C",
	"./news/blog-view-demo.png": "bzZi",
	"./news/image378-1.png": "AE0w",
	"./news/image378-2.png": "UG1D",
	"./news/image378-3.png": "YwGW",
	"./news/news-demo1.png": "q8wD",
	"./news/news-demo2.png": "dA+c",
	"./news/news-demo3.png": "s52Y",
	"./news/news-demo4.png": "jU+i",
	"./news/news-demo5.png": "EsP/",
	"./no_access_img.png": "o5LA",
	"./no_access_img_v2.png": "P2Yr",
	"./notification/nodata_notification.png": "50Np",
	"./page_not_found.png": "Lpn3",
	"./payments/1.png": "+Af2",
	"./payments/2.png": "yIcz",
	"./payments/6.png": "dsMK",
	"./pie-chart.png": "vxVO",
	"./placeholders/user.png": "1bu1",
	"./pnotify/danger.png": "sdoi",
	"./pnotify/default.png": "Y9c9",
	"./pnotify/info.png": "ifjv",
	"./pnotify/success.png": "bHdk",
	"./pnotify/warning.png": "2kux",
	"./product-1.png": "vFsi",
	"./product-2.png": "m9Lt",
	"./product-31.png": "QeVF",
	"./product-40.png": "S/XS",
	"./product-ship.png": "9jY1",
	"./product_link_active.png": "orf6",
	"./product_not_found.png": "rYZM",
	"./purchase_apps_banner.png": "RN/n",
	"./qr-kbank.png": "TqQg",
	"./sand-clock.png": "rKGJ",
	"./shipping-label/Dhl.png": "xbEn",
	"./shipping-label/Flash.png": "9j8+",
	"./shipping-label/J_t.png": "j6ju",
	"./shipping-label/KEX (Pick Up).png": "ypUD",
	"./shipping-label/KEX.png": "yZaU",
	"./shipping-label/Kerry.png": "ClW4",
	"./shipping-label/Suitable-Printer-01 copy.png": "51at",
	"./shipping-label/Suitable-Printer-01.png": "JHVK",
	"./shipping-label/Suitable-Printer-02 copy.png": "JLel",
	"./shipping-label/Suitable-Printer-02.png": "xJUd",
	"./shipping-label/Thaipost.png": "LD4x",
	"./shipping-label/__Thaipost.png": "0BwV",
	"./shipping-label/dhl/label-01.png": "vDJ6",
	"./shipping-label/dhl/label-02.png": "A8gg",
	"./shipping-label/dhl/label-03.png": "Llfi",
	"./shipping-label/dhl/label-04.png": "bEir",
	"./shipping-label/dhl/thumb/thumb-01.png": "Nqnx",
	"./shipping-label/dhl/thumb/thumb-02.png": "cfVa",
	"./shipping-label/dhl/thumb/thumb-03.png": "c8AP",
	"./shipping-label/dhl/thumb/thumb-04.png": "PxRC",
	"./shipping-label/flash/label-01.png": "9u4J",
	"./shipping-label/flash/label-02.png": "f4Hn",
	"./shipping-label/flash/label-03.png": "xjTK",
	"./shipping-label/flash/label-04.png": "s5AU",
	"./shipping-label/flash/label-05.png": "T2FJ",
	"./shipping-label/flash/label-06.png": "W7aT",
	"./shipping-label/flash/label-07.png": "b9dU",
	"./shipping-label/flash/thumb/thumb-01.png": "4hv2",
	"./shipping-label/flash/thumb/thumb-02.png": "6xj+",
	"./shipping-label/flash/thumb/thumb-03.png": "qbyY",
	"./shipping-label/flash/thumb/thumb-04.png": "vLl3",
	"./shipping-label/j_t/label-01.png": "/viO",
	"./shipping-label/j_t/label-02.png": "qLwH",
	"./shipping-label/j_t/label-03.png": "HxWY",
	"./shipping-label/j_t/label-04.png": "hs6R",
	"./shipping-label/j_t/label-05.png": "7WbU",
	"./shipping-label/j_t/label-06.png": "eJoB",
	"./shipping-label/j_t/label-07.png": "UT6L",
	"./shipping-label/j_t/thumb/thumb-01.png": "4bf3",
	"./shipping-label/j_t/thumb/thumb-02.png": "cfX0",
	"./shipping-label/j_t/thumb/thumb-03.png": "ohqW",
	"./shipping-label/j_t/thumb/thumb-04.png": "mN0V",
	"./shipping-label/kerry/label-01.png": "Jl72",
	"./shipping-label/kerry/label-02.png": "MtAv",
	"./shipping-label/kerry/label-03.png": "Ayi7",
	"./shipping-label/kerry/label-04.png": "B6fg",
	"./shipping-label/kerry/thumb/thumb-01.png": "FAA3",
	"./shipping-label/kerry/thumb/thumb-02.png": "fmzp",
	"./shipping-label/kerry/thumb/thumb-03.png": "KbF3",
	"./shipping-label/kerry/thumb/thumb-04.png": "nE7f",
	"./shipping-label/logo_goship.png": "zbew",
	"./shipping-label/receipts/Tax_Invoice.png": "VOsV",
	"./shipping-label/receipts/thumb/thumb_Tax_Invoice.png": "BBgf",
	"./shipping-label/system/label-01.png": "WRoU",
	"./shipping-label/system/label-02.png": "5Xpa",
	"./shipping-label/system/label-03.png": "5PtN",
	"./shipping-label/system/label-04.png": "Y8rO",
	"./shipping-label/system/thumb/thumb-01.png": "79Y/",
	"./shipping-label/system/thumb/thumb-02.png": "EW6F",
	"./shipping-label/system/thumb/thumb-03.png": "QDhc",
	"./shipping-label/system/thumb/thumb-04.png": "1U27",
	"./shipping-label/thaipost/label-01.png": "svjS",
	"./shipping-label/thaipost/label-02.png": "bCrl",
	"./shipping-label/thaipost/label-03.png": "F9rd",
	"./shipping-label/thaipost/label-04.png": "qMkK",
	"./shipping-label/thaipost/label-05.png": "EAAR",
	"./shipping-label/thaipost/label-06.png": "y6Yf",
	"./shipping-label/thaipost/label-07.png": "A8Vd",
	"./shipping-label/thaipost/thumb/thumb-01.png": "PMIi",
	"./shipping-label/thaipost/thumb/thumb-02.png": "E3a3",
	"./shipping-label/thaipost/thumb/thumb-03.png": "LiMW",
	"./shipping-label/thaipost/thumb/thumb-04.png": "mvVd",
	"./signature.png": "JOWC",
	"./signature_light.png": "xkfU",
	"./social/Facebook.png": "IHa9",
	"./social/Instagram.png": "PnhY",
	"./social/Line OA.png": "0XJf",
	"./social/Line.png": "KUTq",
	"./social/Tiktok.png": "3McC",
	"./social/Youtube.png": "KW8K",
	"./social/color/Facebook.png": "BDNS",
	"./social/color/Instagram.png": "wsOm",
	"./social/color/Line OA.png": "nQnQ",
	"./social/color/Line.png": "DLw5",
	"./social/color/Twitter.png": "qWPJ",
	"./social/color/heart.png": "rD3m",
	"./social/color/shopping-cart.png": "OtaF",
	"./social/color/team.png": "2j8W",
	"./social/pages/GoSaas.png": "hUe9",
	"./social/pages/Group.png": "E0M3",
	"./social/pages/instagram.png": "3tH1",
	"./social/pages/messenger.png": "Xv7m",
	"./social_media.png": "lrSF",
	"./special-deal.png": "3jMu",
	"./stores/default-store.png": "IY+A",
	"./stores/expire.png": "y9Kg",
	"./stores/logo-gosell.png": "8NQ8",
	"./stores/logo-goship.png": "N+E5",
	"./stores/tab-logo-gosell.png": "U7+o",
	"./stores/tab-logo-goship.png": "hacz",
	"./stores/thankyou.png": "GUik",
	"./stores/trial.png": "/EKs",
	"./subscription_expired.png": "Gh1r",
	"./subscription_upgraded.png": "CzMZ",
	"./thank_you.png": "iOJO",
	"./thank_you_mail.png": "rkTM",
	"./thum-digital.png": "4pZ8",
	"./thum-ecom.png": "jweU",
	"./thum-global.png": "eK/A",
	"./thum-howto.png": "bwMn",
	"./tiktok.png": "OIFf",
	"./ui/datepicker_trigger.png": "8Xhk",
	"./ui/map_marker.png": "NohS",
	"./unable_create_link.png": "6Rzc",
	"./upload-images.png": "Q9vD",
	"./waiting-print.png": "wL7B",
	"./waiting_approve_cod_wallet.png": "2mS8",
	"./waiting_approve_wallet.png": "DCrw",
	"./waiting_approve_wallet22.png": "dgDV",
	"./waiting_setting.png": "bmCo",
	"./waitingforapprovement.png": "hNXm",
	"./waitingforupload.png": "JdEG",
	"./warning_icon.png": "Yx9h",
	"./watting.png": "rWqk"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "htCk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images ^\.\/.*\.png$
// module id = htCk
// module chunks = 134